module.exports = flarum.core.compat['common/states/PaginatedListState'];